import React from 'react'

import { Document } from 'domain/entities/document'

import * as S from './styles'
import DocumentCard from 'presentation/hospital/components/DoctorRegister/Details/Documents/DocumentCard'

type ResumeProps = {
  resume?: Document
  doctor_id: number
}

const Resume = ({ resume, doctor_id }: ResumeProps) => {
  return (
    <S.Wrapper data-testid="card-resume">
      {resume && <DocumentCard document={resume} doctor_id={doctor_id} />}
    </S.Wrapper>
  )
}

export default Resume
